import { useEffect, useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { DesfaseRelojApi } from "../api/DesfaseRelojApi";
import { useFechaHoraReloj } from "./useFechaHoraReloj";
import { getErrorFromResponse } from "../../../../../utility/utils";

// Reloj de un contexto con su desfase, junto con el formulario que lo cambia
export const useDesfaseReloj = ({ contexto, onCambioGuardado }) => {
    const reloj = useFechaHoraReloj(contexto);

    const { registrarCambioReloj, cargando } = DesfaseRelojApi();

    const [modalAbierto, setModalAbierto] = useState(false);

    const {
        register: formRegister,
        control: formControl,
        watch,
        reset,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            cambiar_fecha: false,
            fecha_hora_configurada: null,
        },
    });

    const cambiarFecha = watch("cambiar_fecha");
    const fechaElegida = watch("fecha_hora_configurada");

    // al pasar a fecha manual el campo arranca en la fecha y hora del reloj, en
    // lugar de quedar vacío: casi siempre se cambia a partir de ella
    useEffect(() => {
        if (cambiarFecha && !getValues("fecha_hora_configurada")) {
            setValue("fecha_hora_configurada", reloj.obtenerFechaHora());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cambiarFecha]);

    // Un movimiento con fecha anterior al corte del último cierre de bodega no
    // entra en ese cierre, que ya está cerrado, ni en el siguiente, que arranca
    // después del corte. No se restringe, solo se advierte
    const cierreBodegaPosteriorAFechaElegida = Boolean(
        cambiarFecha &&
        fechaElegida &&
        reloj.fechaUltimoCierreBodega &&
        moment(fechaElegida).isSameOrBefore(
            moment(reloj.fechaUltimoCierreBodega),
        ),
    );

    // el formulario abre con el reloj como está: con desfase, marcado y con su
    // fecha y hora; en tiempo actual, desmarcado
    const AbrirModal = () => {
        reset({
            cambiar_fecha: !reloj.esTiempoActual,
            fecha_hora_configurada: reloj.esTiempoActual
                ? null
                : reloj.obtenerFechaHora(),
        });

        setModalAbierto(true);
    };

    const CerrarModal = () => setModalAbierto(false);

    const GuardarCambio = async (data) => {
        try {
            const response = await registrarCambioReloj({
                contexto,
                cambiar_fecha: Boolean(data.cambiar_fecha),
                fecha_hora_configurada: data.cambiar_fecha
                    ? moment(data.fecha_hora_configurada).format()
                    : null,
            });

            reloj.ActualizarEstado(response);
            setModalAbierto(false);

            NotificationManager.success(
                response.es_tiempo_actual
                    ? "El reloj volvió a la fecha y hora actual"
                    : "Fecha y hora del reloj actualizada",
                "Éxito",
                3000,
            );

            if (onCambioGuardado) onCambioGuardado();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cambiar la fecha y hora del reloj",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        contexto,
        diferenciaMs: reloj.diferenciaMs,
        esTiempoActual: reloj.esTiempoActual,
        correlativoConfigurado: reloj.correlativoConfigurado,

        modalAbierto,
        AbrirModal,
        CerrarModal,

        formRegister,
        formControl,
        errors,
        cambiarFecha,
        fechaUltimoCierreBodega: reloj.fechaUltimoCierreBodega,
        cierreBodegaPosteriorAFechaElegida,
        GuardarCambio: handleSubmit(GuardarCambio),

        cargando,
    };
};
